/** Set when we successfully obtain a Tier 1 Checkout URL (before redirect). Drives CTA copy with GET /billing/status. */
const TIER1_CHECKOUT_ATTEMPTED_KEY = "tier1_checkout_attempted_v1";

export function hasTier1CheckoutAttempted(): boolean {
  try {
    return localStorage.getItem(TIER1_CHECKOUT_ATTEMPTED_KEY) === "1";
  } catch {
    return false;
  }
}

export function markTier1CheckoutAttempted(): void {
  try {
    localStorage.setItem(TIER1_CHECKOUT_ATTEMPTED_KEY, "1");
  } catch {
    // ignore
  }
}
